import React                           from "react";
import { StyleSheet, TextInput, View } from "react-native";
import Icon                            from "react-native-vector-icons/Feather";
import palette                         from "../../styles/palette";

export default function StyledInput({
  style,
  icon,
  center,
  innerRef,
  ...props
}) {
  return (
    <View>
      <TextInput
        ref={innerRef}
        placeholderTextColor={palette.light_grey}
        style={{}}
        style={[
          styles.styled_input,
          style,
          icon && { paddingRight: 36 },
          center && { textAlign: "center" },
        ]}
        {...props}
      />
      {icon && (
        <Icon
          name={icon}
          size={18}
          color={palette.grey}
          style={[styles.styled_input__icon]}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  styled_input: {
    borderColor: palette.light_grey,
    borderWidth: StyleSheet.hairlineWidth,
    paddingVertical: 12,
    paddingHorizontal: 12,
    fontSize: 16,
    fontWeight: "400",
    fontFamily: "acumin-pro, sans-serif",
    outlineColor: palette.transparent,
    outlineOffset: 3,
    outlineWidth: 0,
    borderRadius: 2,
  },
  styled_input__icon: {
    position: "absolute",
    right: 16,
    top: "calc(50% - 10px)",
  },
});
